import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { getAuthHeader, showToast, Loader } from '../tool.js';
import axios from 'axios';
import {
    FormControl, InputLabel, MenuItem, Select
} from '@mui/material';
import { COUNTRY, COUNTRYLOCATION, UPLOADIMG } from '../../endPoints.js/index.js';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FaqAddEdit from '../editPackage/country.location.faq.js';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const EditCountryLocation = () => {
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [activeTab, setActiveTab] = useState("country-location");
    const [faqs, setFaqs] = useState([]);
    const [newFaqs, setNewFaqs] = useState([]);
    const { id } = useParams();

    const [formData, setFormData] = useState({
        name: '',
        imageUrl: '',
        metaTitle: '',
        metaKeywords: '',
        metaDescription: '',
        status: '',
        url: '',
        countryId: '',
        content: ''
    });
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {

        const fetchCountryLocation = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${COUNTRYLOCATION}`, {
                    headers: {
                        'Authorization': `Bearer ${getAuthHeader()}`
                    }
                });
                const data = response.data.data.find(item => item.id === id);

                if (data) {
                    setFormData({
                        name: data.name || '',
                        imageUrl: data.imageUrl || '',
                        metaTitle: data.metaTitle || '',
                        metaKeywords: data.metaKeywords || '',
                        metaDescription: data.metaDescription || '',
                        status: data.status || '',
                        url: data.url || '',
                        countryId: data.countryId || '',
                        content: data.content || '',
                    });
                }
                setFaqs(data?.faqs || []);

            } catch (error) {
                console.error('Error fetching agents:', error);
                showToast("ERROR", "Failed to fetch agents.");
            } finally {
                setLoading(false);
            }
        };

        fetchCountryLocation();

    }, [id]);
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get(COUNTRY, {
                    headers: {
                        'Authorization': `Bearer ${getAuthHeader()}`
                    }
                });
                setCountries(response.data.data);
            } catch (error) {
                console.error('Failed to fetch countries:', error);
            }
        };

        fetchCountries();
    }, []);
    const handleChange = (event) => {
        const { name, value, type, files } = event.target;
        if (type === 'file') {
            setImageFile(files[0]);
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: value
            }));
        }
    };
    const uploadImage = async () => {
        if (!imageFile) return '';
        const formData = new FormData();
        formData.append('image', imageFile);

        try {
            const response = await axios.post(UPLOADIMG, formData, {
                headers: {
                    'Authorization': `Bearer ${getAuthHeader()}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data || '';
        } catch (error) {
            console.error('Error uploading image:', error.response?.data);
            showToast("ERROR", error.response?.data?.message || 'Image upload failed');
            return '';
        }
    };
    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        try {
            const imageUrl = await uploadImage();
            // Faqs Modificiation.
            let totalFaqs = [...faqs, ...newFaqs];
            if (totalFaqs[0]?.question === "" && totalFaqs[0]?.answer === "") {
                totalFaqs = [];
            }
            const requestBody = {
                name: formData.name,
                metaTitle: formData.metaTitle,
                metaKeywords: formData.metaKeywords,
                metaDescription: formData.metaDescription,
                status: formData.status,
                imageUrl: imageUrl || formData.imageUrl,
                url: formData.url,
                countryId: formData.countryId,
                content: formData.content,
                faqList: totalFaqs
            };
            console.log(requestBody);
            const response = await axios.put(`${COUNTRYLOCATION}/${id}`, requestBody, {
                headers: {
                    Authorization: `Bearer ${getAuthHeader()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.success) {
                showToast("SUCCESS", response.data.msg || 'Update successful');

            } else {
                showToast("ERROR", response.data.msg || 'Update failed');
            }
        } catch (error) {
            showToast("ERROR", error.response?.data?.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='container mt-5'>
            {loading ? (
                <Loader />
            ) : (
                <Container> 
                    <div className='d-flex container m-2'>
                        <button
                            className={`step-button ${activeTab === "country-location" ? "active" : ""}`}
                            onClick={() => setActiveTab("country-location")}
                        >
                            Add Country Location
                        </button>
                        <button
                            className={`step-button ${activeTab === "faq" ? "active" : ""}`}
                            onClick={() => setActiveTab("faq")}
                        >
                            FAQ
                        </button>
                    </div>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                    >
                        <Box
                            component="div"
                            className={activeTab === 'country-location' ? 'd-block' : 'd-none'}
                            sx={{ '& > :not(style)': { m: 1, width: '100%' } }}
                            autoComplete="off"
                        >
                            <div className="row">
                                <div className="col-lg-6 d-flex flex-column">
                                    <div className=''>
                                        <TextField
                                            id="name"
                                            label="Enter Package Name"
                                            variant="filled"
                                            required
                                            className='w-100'
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <TextField
                                            id="metaTitle"
                                            label="Enter Meta Title"
                                            variant="filled"
                                            required
                                            className='w-100'
                                            name="metaTitle"
                                            value={formData.metaTitle}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    {formData.imageUrl && (
                                        <img
                                            src={formData.imageUrl}
                                            alt={formData.name}
                                            style={{
                                                width: '100%',
                                                height: '150px',
                                                border: '2px solid smokewhite',
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                borderRadius: '4px' // Optional for smooth edges
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <TextField
                                        id="metaTitle"
                                        label="Enter Meta Title"
                                        variant="filled"
                                        required
                                        className='w-100'
                                        name="metaTitle"
                                        value={formData.metaTitle}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <TextField
                                        id="metaKeywords"
                                        label="Enter Meta Keywords"
                                        variant="filled"
                                        className='w-100'
                                        name="metaKeywords"
                                        value={formData.metaKeywords}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <textarea
                                        rows={5}
                                        className='form-control'
                                        placeholder="Enter Meta Description"
                                        name="metaDescription"
                                        value={formData.metaDescription}
                                        onChange={handleChange}
                                        style={{ border: '1px solid lightgrey', borderRadius: '5px', backgroundColor: '#f3f3f3' }}
                                    />
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-lg-12'>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    'heading', '|', 'bold', 'italic', 'underline', '|', 'link', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'mediaEmbed', 'codeBlock', '|', 'undo', 'redo', '|', 'alignment', 'fontFamily', 'fontSize', 'highlight', 'specialCharacters'
                                                ],
                                                shouldNotGroupWhenFull: true
                                            },
                                            language: 'en',
                                            initialData: '<em>Write Country Location Description!</em>',
                                            codeBlock: {
                                                languages: [
                                                    { language: 'javascript', label: 'JavaScript' },
                                                    { language: 'python', label: 'Python' },
                                                    { language: 'java', label: 'Java' }
                                                ]
                                            },
                                        }}
                                        data={formData.content}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setFormData(prevData => ({ ...prevData, content: data }));
                                        }}
                                    ></CKEditor>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <TextField
                                        id="url"
                                        label="Enter Url"
                                        variant="filled"
                                        required
                                        className='w-100'
                                        name="url"
                                        value={formData.url}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <select
                                        className='w-100'
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                        required
                                        style={{ height: '52px', border: '1px solid lightgrey', borderRadius: '5px', backgroundColor: '#f3f3f3' }}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="inactive">Inactive</option>
                                        <option value="active">Active</option>
                                    </select>
                                </div>
                                <div className="col-lg-6">
                                    <FormControl sx={{ m: 0, width: '100%' }}>
                                        <InputLabel id="country-select-label">Select Country</InputLabel>
                                        <Select
                                            id='country'
                                            label="Select Country"
                                            style={{ height: '55px', border: '1px solid lightgrey', borderRadius: '4px' }}
                                            value={formData.countryId}
                                            name="countryId"
                                            fullWidth
                                            onChange={handleChange}
                                        >
                                            {countries.map((country) => (
                                                <MenuItem key={country.id} value={country.id}>
                                                    {country.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <input
                                        type="file"
                                        className='w-100 p-2'
                                        name="imageFile"
                                        onChange={handleChange}
                                        style={{ height: '52px', border: '1px solid lightgrey', borderRadius: '5px', backgroundColor: '#f3f3f3' }}
                                    />
                                </div>
                            </div>
                        </Box>
                        <div className={activeTab === 'faq' ? 'd-block p-3' : 'd-none'}>
                            <FaqAddEdit faqs={faqs} setFaqs={setFaqs} newFaqs={newFaqs} setNewFaqs={setNewFaqs} />
                        </div>
                        <div className="d-block p-3">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className='w-100'
                            >
                                Submit
                            </Button>
                        </div>
                    </Box>
                </Container>

            )}
        </div>
    );
}


export default EditCountryLocation


